import React from 'react';
import { ArrowRight, Droplets, Filter, Home, Wrench } from 'lucide-react';
const SERVICES = [{
  icon: Droplets,
  title: 'AZ water softener installation and service',
  text: 'Professional water softener setup, replacement, and maintenance for Arizona hard water conditions.'
}, {
  icon: Filter,
  title: 'Whole house water filter systems in Arizona',
  text: 'Improve water quality for every tap with whole house filtration designed for local water needs.'
}, {
  icon: Droplets,
  title: 'Reverse osmosis drinking water systems',
  text: 'Cleaner, better-tasting water from dedicated RO systems installed and maintained by local pros.'
}, {
  icon: Home,
  title: 'Residential plumbing services in Phoenix, Casa Grande, and Tucson',
  text: 'Full-service home plumbing including faucets, toilets, disposals, leak repair, valves, and water heaters.'
}];
const POPULAR_SERVICES = ['Water softener tune-ups and upgrades', 'Whole house carbon and sediment filtration', 'Reverse osmosis filter and membrane replacement', 'Faucet, toilet, disposal, and water heater repairs'];
export function Services() {
  return <section id="services" className="w-full bg-slate-50" data-id="element-143" data-mp="2xbrrxeucmbqp">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6" data-id="element-144" data-mp="2xdcn96ohlypm">
        <div className="max-w-2xl" data-id="element-145" data-mp="32acsjfdiixfo">
          <span className="text-sm font-semibold uppercase tracking-wide text-sky-600" data-id="element-146" data-mp="32be21fevrbva">What we do</span>
          <h2 className="mt-2 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-147" data-mp="3q18fnz70x4gl">
            Water solutions and home plumbing, done right
          </h2>
          <p className="mt-3 text-lg text-slate-600" data-id="element-148" data-mp="3g1hjzu6q8jex">
            Specialized service for Arizona hard water plus dependable plumbing for every room in your home.
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-149" data-mp="24m2nerifjtkc">
          {SERVICES.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-all hover:-translate-y-0.5 hover:border-sky-200 hover:shadow-md" data-id="element-150" data-mp="29ns1yh4v2pd6">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-50 text-sky-600 transition-colors group-hover:bg-sky-600 group-hover:text-white" data-id="element-151" data-mp="1lkv779jd8bg5">
                <Icon className="h-6 w-6" data-id="element-152" data-mp="1bsfmi4gop8rk" />
              </div>
              <h3 className="mt-5 font-heading text-xl font-semibold tracking-tight text-slate-900" data-id="element-153" data-mp="16tuwsyz267hd">{title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600" data-id="element-154" data-mp="11tgr3nkxj9mi">{text}</p>
              <a href="#contact" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-sky-700 hover:text-sky-800" data-id="element-155" data-mp="xs4yd96re8a3">
                Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-156" data-mp="sw6cptctf4dd" />
              </a>
            </article>)}
        </div>

        <div className="mt-8 rounded-2xl border border-sky-100 bg-sky-50 p-6 sm:p-8" data-id="element-157" data-mp="2n95wzzs54mqz">
          <div className="flex items-start gap-4" data-id="element-158" data-mp="2uqc8ynx5zq1a">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-sky-600 shadow-sm" data-id="element-159" data-mp="2upj823kvzur2">
              <Wrench className="h-5 w-5" data-id="element-160" data-mp="34gncwagulz86" />
            </div>
            <div data-id="element-161" data-mp="34j9tt0pmpr32">
              <h3 className="font-heading text-xl font-semibold text-slate-900" data-id="element-162" data-mp="39ga09cqe4vup">Popular services for Arizona homeowners</h3>
              <p className="mt-1 text-sm text-slate-600" data-id="element-163" data-mp="2bt1d7daqreql">Ask about local hard-water and residential plumbing solutions:</p>
              <ul className="mt-5 grid gap-3 text-sm font-medium text-slate-700 sm:grid-cols-2" data-id="element-164" data-mp="2gsduzjmr9vmb">
                {POPULAR_SERVICES.map(service => <li key={service} className="flex gap-2" data-id="element-165" data-mp="2psaqa43nhsqc">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-sky-600" aria-hidden="true" data-id="element-166" data-mp="2ptu3flu0fnnw" />
                    {service}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}